import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility.js';

const initialState = {
    printing :false
};

const printing = ( state = initialState, action ) => {
    return updateObject( state, { printing: true} );
};

const not_printing = ( state = initialState, action ) => {
    return updateObject( state, { printing: false} );
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
    	case actionTypes.PRINTING: return printing( state, action );
    	case actionTypes.NOT_PRINTING: return not_printing( state, action );
        default: return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/_store/reducers/printing.js